module.exports = __webpack_public_path__ + "static/img/1.5aaa766.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/eng/1.png
// module id = 0ZuH
// module chunks = 0